import { BrakeLiningTable } from '@/features/brakes/BrakeLiningTable';

export const BrakeLiningPage = () => {
    return <BrakeLiningTable />;
};
